<div class="project-logbook-details" *ngIf="properties != null && !forbidden">
  <project-details-logbook-event-user-on-properties [event]="event" [properties]="properties"></project-details-logbook-event-user-on-properties>
  <ng-container *ngIf="eventObject != '' else noeventobject">
    <ng-container [ngSwitch]="eventObject">
      <ng-template [ngSwitchCase]="'requests'"> 
        <project-details-logbook-properties-request-properties
          [event]="event"
          [properties]="properties"
        ></project-details-logbook-properties-request-properties>
      </ng-template>
      <ng-template [ngSwitchCase]="'versions'">
        <project-details-logbook-properties-version-properties
          [event]="event"
          [properties]="properties"
        ></project-details-logbook-properties-version-properties>
      </ng-template>
      <ng-template [ngSwitchCase]="'share'">
        <project-details-logbook-properties-share-properties
          [event]="event"
          [properties]="properties"
        ></project-details-logbook-properties-share-properties>
      </ng-template>
      <ng-template [ngSwitchCase]="'custom_forms'">
        <project-details-logbook-properties-request-properties
          [event]="event"
          [properties]="properties"
        ></project-details-logbook-properties-request-properties>
      </ng-template>
      <div *ngSwitchDefault>
        No event defined yet.
      </div>
    </ng-container>
  </ng-container>
  <ng-template #noeventobject>
    <h3>Pending event </h3>
  </ng-template>
  
</div>
<div class="loader">
  <div class="dimmed dimmed-logbook" [hidden]="properties != null || forbidden">
    <div class="dimmed_flex" >
      <div class="dimmed_avatar"></div>
      <div class="dimmed_title"></div>
      <div class="dimmed_title dimmed_cont"></div>
    </div>
    <div class="dimmed_subtitle"></div>
  </div>
  <!--  <core-helpers-box-loading [hidden]="properties != null || forbidden"></core-helpers-box-loading> -->
</div>

<div *ngIf="forbidden" class="event-not-allowed">
  <core-helpers-box-alert-message-icon
      [text]="'You are not allowed to see the details.'"
      [icon]="'warning'"
  ></core-helpers-box-alert-message-icon>
</div>
